import { values } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
export const peopleSchemasSelector = (state) => state.peopleSchemas;
export const peopleSchemasResourcesSelector = createSelector(peopleSchemasSelector, (peopleSchema) => values(peopleSchema.resources));
